module.exports = __webpack_public_path__ + "static/media/search-blue.61250033.svg";